import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
/* eslint-disable @typescript-eslint/no-var-requires */
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink';
import { SvgComponent } from '@terminus-ui/svg';

const community = require('../../assets/images/terminus-community.svg');
const academy = require('../../assets/images/resource-center.svg');

export type Resource = {
  description: string;
  name: string;
  path: string;
  svg: SVGElement | string;
};

export const ResourceList: Resource[] = [
  {
    description: `Browse our catalog of guided training courses, designed to educate learners on DemandScience products, processes, and account-based principles.`,
    name: 'Resource Center',
    path: 'https://customer-academy.terminus.com/app',
    svg: academy,
  },
];

@Component({
  selector: 'lib-home-resource-list',
  templateUrl: './resource-list.component.html',
  styleUrls: ['./resource-list.component.scss'],
  imports: [CommonModule, FontAwesomeModule, SvgComponent],
})
export class ResourceListComponent {
  public externalIcon = faExternalLink;
  public resourceList = ResourceList;
}
